import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { APPS } from "../../../../constants/AppsConstants.ts";
import { useLogEvents } from "../../../../hooks/useLogEvents.ts";
import { useManualPlacementConfig } from "../../../../hooks/useManualPlacementConfig.ts";
import { useAppStore } from "../../../../hooks/useStores";
import { isFoxApps } from "../../../../utils";
import FoxConfigs from "./FoxConfigs/FoxConfigs.tsx";
import ImageEditingConfigs from "./ImageEditingConfigs/ImageEditingConfigs.tsx";
import styles from "./ImageToImageConfig.module.scss";
import { ImageEditingViewMode } from "../../../../models/image-to-image.ts";

const ImageToImageConfig = () => {
	const { imageToImageStore, playgroundStore } = useAppStore();
	const { logImageEditingEvents } = useLogEvents();
	const { checkResolutions } = useManualPlacementConfig();

	useEffect(() => {
		imageToImageStore.errors = {};
		playgroundStore.imageEditingViewMode = ImageEditingViewMode.SINGLE;
	}, [])

	useEffect(() => {
		if (playgroundStore.selectedConfig !== APPS.IMAGE_TO_IMAGE) {
			playgroundStore.handleAppChange(APPS.IMAGE_TO_IMAGE);
		}
	}, [imageToImageStore.isGeneratingImages]);

	const handleGenerateImageToImage = async () => {
		await imageToImageStore.generateImageToImage();
		checkResolutions();
		logImageEditingEvents();
	};

	return (
		<Box className={styles.wrapper}>
			{isFoxApps() ? (
				<FoxConfigs handleGenerateImageToImage={handleGenerateImageToImage} />
			) : (
				<ImageEditingConfigs handleGenerateImageToImage={handleGenerateImageToImage} />
			)}
		</Box>
	);
};

export default observer(ImageToImageConfig);
